export enum FilterOperators {
	EQUAL = 'EQUAL',
	UNEQUAL = 'UNEQUAL',
	GREATER = 'GREATER',
	SMALLER = 'SMALLER',
	CONTAINS = 'CONTAINS',
}
